import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Image, Upload, X, Save } from 'lucide-react';
import { API_BASE_URL } from '../constants';
import '../App.css';

const BannerManager = () => {
    const [banners, setBanners] = useState([null, null, null, null, null]); // 5 positions
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });

    useEffect(() => {
        fetchBanners();
    }, []);

    const fetchBanners = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_BASE_URL}/file/banners`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            // Convert response to banner URLs array
            const bannerData = response.data;
            const bannerUrls = bannerData.map(b =>
                b.fileKey ? `${API_BASE_URL}/file/banner/${b.position}?t=${new Date().getTime()}` : null
            );
            setBanners(bannerUrls);
        } catch (error) {
            console.error("Error fetching banners", error);
        }
    };

    const handleFileChange = async (position, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);

        setLoading(true);
        setMessage({ text: '', type: '' });

        try {
            const token = localStorage.getItem('token');
            await axios.post(`${API_BASE_URL}/file/banner/${position}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`
                }
            });

            setMessage({ text: `Cập nhật banner vị trí ${position + 1} thành công!`, type: 'success' });
            fetchBanners(); // Refresh banners
        } catch (error) {
            console.error("Upload failed", error);
            setMessage({ text: 'Có lỗi xảy ra khi tải lên.', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (position) => {
        if (!window.confirm(`Bạn có chắc muốn xóa banner vị trí ${position + 1}?`)) return;

        setLoading(true);
        setMessage({ text: '', type: '' });

        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${API_BASE_URL}/file/banner/${position}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            setMessage({ text: `Đã xóa banner vị trí ${position + 1}`, type: 'success' });
            fetchBanners();
        } catch (error) {
            console.error("Delete failed", error);
            setMessage({ text: 'Có lỗi xảy ra khi xóa.', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container">
            <div className="page-header">
                <h1>Quản lý Banner</h1>
                <p style={{ color: '#666', marginTop: '8px' }}>Tối đa 5 banner, sẽ tự động chuyển đổi mỗi 3 giây trên app</p>
            </div>

            {message.text && (
                <div className={`alert ${message.type === 'error' ? 'alert-danger' : 'alert-success'}`} style={{ marginBottom: '20px' }}>
                    {message.text}
                </div>
            )}

            <div className="content-card">
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                    gap: '20px',
                    maxWidth: '1200px',
                    margin: '0 auto'
                }}>
                    {banners.map((bannerUrl, index) => (
                        <div key={index} style={{
                            border: '2px dashed #ccc',
                            borderRadius: '8px',
                            padding: '16px',
                            position: 'relative',
                            backgroundColor: '#fafafa'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '12px'
                            }}>
                                <span style={{
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: '14px'
                                }}>
                                    Vị trí {index + 1}
                                </span>
                                {bannerUrl && (
                                    <button
                                        onClick={() => handleDelete(index)}
                                        disabled={loading}
                                        style={{
                                            background: '#ff4d4f',
                                            border: 'none',
                                            borderRadius: '50%',
                                            width: '28px',
                                            height: '28px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white'
                                        }}
                                        title="Xóa banner"
                                    >
                                        <X size={16} />
                                    </button>
                                )}
                            </div>

                            <div style={{
                                width: '100%',
                                aspectRatio: '16/9',
                                border: '1px solid #e0e0e0',
                                borderRadius: '6px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden',
                                backgroundColor: '#fff',
                                position: 'relative'
                            }}>
                                {bannerUrl ? (
                                    <img
                                        src={bannerUrl}
                                        alt={`Banner ${index + 1}`}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                ) : (
                                    <div style={{
                                        color: '#aaa',
                                        textAlign: 'center',
                                        padding: '20px'
                                    }}>
                                        <Image size={40} style={{ marginBottom: '8px' }} />
                                        <p style={{ fontSize: '13px', margin: 0 }}>Chưa có ảnh</p>
                                    </div>
                                )}
                            </div>

                            <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                marginTop: '12px',
                                padding: '10px 16px',
                                backgroundColor: bannerUrl ? '#1890ff' : '#52c41a',
                                color: 'white',
                                borderRadius: '6px',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                opacity: loading ? 0.6 : 1
                            }}>
                                <Upload size={16} />
                                {bannerUrl ? 'Thay đổi ảnh' : 'Tải lên ảnh'}
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleFileChange(index, e)}
                                    disabled={loading}
                                    style={{ display: 'none' }}
                                />
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BannerManager;